import { Route } from "react-router-dom";
import { BuilderMain } from "features/builder";
import { CourseTopPage } from "features/courses/Top";
import { FreeMapGamePage } from "features/courses/free";
import { Shoot } from "features/courses/experiment/game/camera";
import { ProgramGamePage } from "features/courses/program/game";
import { AlgorithmGamePage } from "features/courses/algorithm/game";
import { ProgramLevelMapPage } from "features/courses/program/level";
import { AlgorithmLevelMapPage } from "features/courses/algorithm/level";
import { NishishinjukuGamePage } from "features/courses/nishishinjuku/game";
import { AlgorithmCameraGamePage } from "features/courses/experiment/game";
import { NishishinjukuLevelMapPage } from "features/courses/nishishinjuku/level";

export const CoursePageRoutes = (
  <>
    <Route index element={<CourseTopPage />} />
    <Route path="algorithm">
      <Route path="stage/:stageId" element={<AlgorithmLevelMapPage />} />
      <Route
        path="stage/:stageId/step/:stepId"
        element={<AlgorithmGamePage />}
      />
    </Route>
    <Route path="program">
      <Route path="stage/:stageId" element={<ProgramLevelMapPage />} />
      <Route path="stage/:stageId/step/:stepId" element={<ProgramGamePage />} />
    </Route>
    <Route path="nishishinjuku">
      <Route path="stage/:stageId" element={<NishishinjukuLevelMapPage />} />
      <Route
        path="stage/:stageId/step/:stepId"
        element={<NishishinjukuGamePage />}
      />
    </Route>
    <Route path="experiment">
      <Route path="camera" element={<AlgorithmCameraGamePage />} />
      <Route path="shoot" element={<Shoot />} />
      <Route path="builder" element={<BuilderMain />} />
      <Route path="freemap" element={<FreeMapGamePage />} />
    </Route>
  </>
);
